import { C } from "@/brand/tokens";

/**
 * FaithMonogram — compact "F1" mark.
 *
 * Tones:
 *   - "primary" (default) — Deep Mineral Blue square, Witness White F1, brass underrule.
 *   - "ink"               — Smoked Ink square (used in dark footer for emphasis).
 *   - "light"             — Dry Stone square with ink F1 (for light surfaces).
 */
export function FaithMonogram({ size = 56, tone = "primary" }) {
  const config = {
    primary: { bg: C.surfacePrimary, fg: C.textOnDark, rule: C.accentMetal },
    ink: { bg: C.bgDark, fg: C.textOnDark, rule: C.accentMetal },
    light: { bg: C.surfaceLight, fg: C.textOnLight, rule: C.accentMetal },
  }[tone];

  return (
    <span
      className="inline-flex items-center justify-center select-none relative"
      style={{ width: size, height: size, background: config.bg }}
      aria-label="Faith 1st monogram"
    >
      <span
        className="font-cormorant leading-none"
        style={{
          color: config.fg,
          fontSize: size * 0.62,
          fontWeight: 500,
          letterSpacing: "-0.02em",
        }}
      >
        F
        <span style={{ marginLeft: "0.04em" }}>1</span>
      </span>
      <span
        aria-hidden="true"
        className="absolute"
        style={{
          left: "22%",
          right: "22%",
          bottom: "16%",
          height: 1,
          background: config.rule,
        }}
      />
    </span>
  );
}
